import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

// img
import g1 from "../../../Assets/images/g1.png";
import EarningFeature from "./components/earningFeature";
import { GET_EARNING } from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import { LineChart } from "@mui/x-charts";
import {
  GroupByFilterOptionArr,
  datesLabels,
  monthsLabels,
  weekLabels,
} from "../../../utilities/const";

const checkGraphIsNOtEmpty = (series) => {
  return series?.reduce((prev, next) => prev + next, 0) === 0;
};

const Earnings = () => {
  const [earning, setEarning] = useState();
  const [graphFilter, setGraphFilter] = useState(
    GroupByFilterOptionArr[0].value
  );
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const getEarning = async () => {
    try {
      const res = await GET_EARNING();

      if (res?.data?.success) {
        setEarning(res?.data?.data);
      } else {
        toast.error("something went wrong");
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getEarning();
  }, []);

  useEffect(() => {
    if (graphFilter === "week") {
      if (!earning?.weeklyGraphData) {
        return;
      }
      setLabels(weekLabels);
      const newSeries = earning?.weeklyGraphData?.map((item) => {
        return item?.revenue;
      });

      if (checkGraphIsNOtEmpty(newSeries)) {
        return setSeries([]);
      }

      setSeries(newSeries);
    }

    if (graphFilter === "month") {
      if (!earning?.monthlyGraphData) {
        return;
      }
      setLabels(datesLabels);

      const newSeries = earning?.monthlyGraphData?.map((item) => {
        return item?.revenue;
      });

      if (checkGraphIsNOtEmpty(newSeries)) {
        return setSeries([]);
      }
      setSeries(newSeries);
    }
    if (graphFilter === "year") {
      if (!earning?.monthWiseTotalRevenue) {
        return;
      }
      setLabels(monthsLabels);

      const newSeries = earning?.monthWiseTotalRevenue?.map((item) => {
        return item?.totalRevenue;
      });

      if (checkGraphIsNOtEmpty(newSeries)) {
        return setSeries([]);
      }
      setSeries(newSeries);
    }
  }, [graphFilter, earning]);

  return (
    <>
      <section className="earning position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Earnings</h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <EarningFeature data={earning} />
            </Col>
            <Col lg="12" className="my-2">
              <div className="cardCstm box px-lg-5 py-lg-4 bg-white rounded p-3">
                <div className="top pb-2 d-flex align-items-center justify-content-between gap-10">
                  <h6 className="m-0 fw-sbold">Data Graph Analysis</h6>
                  <div className="right">
                    <div className="d-flex align-items-center gap-10">
                      <label htmlFor="" className="form-label m-0">
                        Filter:
                      </label>
                      <Form.Select
                        aria-label="Default select example"
                        className="form-control fw-sbold h-auto"
                        defaultValue={GroupByFilterOptionArr[0].value}
                        onChange={(e) => {
                          setGraphFilter(e.target.value);
                        }}
                      >
                        {GroupByFilterOptionArr.map((item) => {
                          return (
                            <option value={item.value}>{item.label}</option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  </div>
                </div>
                <div className="graph">
                  {/* <img src={g1} alt="" className="img-fluid w-100" /> */}
                  {
                    <LineChart
                      colors={["#e4887e"]}
                      xAxis={[
                        {
                          scaleType: "point",
                          data: labels,
                        },
                      ]}
                      series={[
                        {
                          data: series,
                          area: true
                        },
                      ]}
                      width={800}
                      height={350}
                    />
                  }
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Earnings;
